import React, { useState, useEffect } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { removeAlert } from "./../../reducers/userConfigSlice";
// Icons
import { TbSquareRoundedCheck, TbSquareRoundedX, TbAlertSquareRounded, TbInfoSquareRounded } from "react-icons/tb";
// Styles
import "./style.css";

export const Alert = () => {
  const alerts = useSelector((state) => state.aplicationConfig.userConfig.alerts);

  return (
    <div className="alert-container">{alerts && alerts.map((alert, index) => <AlertComponent key={alert.id} alert={alert} index={index + 1} />)}</div>
  );
};

const AlertComponent = ({ alert, index }) => {
  const timeBadge = 5000;
  const persistent = alert.type === "error";
  const [progress, setProgress] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    if (persistent) return undefined;
    const interval = setInterval(() => setProgress(value => Math.min(100, value + 1)), timeBadge / 100);
    const timeout = setTimeout(() => dispatch(removeAlert(alert.id)), timeBadge);
    return () => { clearTimeout(timeout); clearInterval(interval); };
  }, [alert.id, dispatch, persistent]);

  const getColor = (type) => {
    switch (type) {
      case "success":
        return "var(--color-success)";
      case "warning":
        return "var(--color-pending)";
      case "error":
        return "var(--color-error)";
      default:
        return "var(--color-process)";
    }
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case "success":
        return <TbSquareRoundedCheck style={{ color: getColor(type) }} />;
      case "error":
        return <TbSquareRoundedX />;
      case "warning":
        return <TbAlertSquareRounded />;
      default:
        return <TbInfoSquareRounded style={{ color: getColor(type) }} />;
    }
  };

  return (
    <div
      className="alert-banner show"
      role={alert.type === "error" ? "alert" : "status"}
      aria-atomic="true"
    >
      <div className="alert-banner-body">
        <div className="message-icon" aria-hidden="true">{getAlertIcon(alert.type)}</div>
        <div>
          <div className="message-title">{alert.title}</div>
          <div className="message-description">{typeof alert.message === "string" && alert.message}</div>
        </div>
        <button type="button" className="alert-close" aria-label="Cerrar aviso" onClick={() => dispatch(removeAlert(alert.id))}>×</button>
      </div>
      {!persistent && <div aria-hidden="true" id={"progress-line" + index} className="progress-line" style={{ backgroundColor: getColor(alert.type), width: `${progress}%` }}></div>}
    </div>
  );
};
